import { MODAL_TYPES } from '../../../common/constants'

export const getModalPayloads = (props) => {
    const { modalType, selectedTableRows, params, columns } = props
    const { DELETE_MODAL, OFFER_BASE_MODAL, TEMPLATES_MODAL, CHANGE_AGENT_MODAL, EXPORT_ADS_MODAL, EXPORT_DATA_MODAL, PROPERTY_PRINT_FORM_MODAL } =
        MODAL_TYPES

    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    callbackId: 'delete-properties',
                    appModule: 'property',
                },
            }
        case OFFER_BASE_MODAL:
            return {
                modalType: OFFER_BASE_MODAL,
                modalProps: {
                    items: selectedTableRows,
                    offerType: 'property',
                },
            }
        case TEMPLATES_MODAL:
            return {
                modalType: TEMPLATES_MODAL,
                modalProps: { selectedProperties: selectedTableRows },
            }
        case CHANGE_AGENT_MODAL:
            return {
                modalType: CHANGE_AGENT_MODAL,
                modalProps: {
                    modalData: selectedTableRows.map((row) => ({
                        id: row.id,
                        internalAppId: row.internalAppId,
                        city: row.city?.name,
                        agentFirstName: row.primaryAgent?.firstName,
                        agentLastName: row.primaryAgent?.lastName,
                    })),
                },
            }
        case EXPORT_ADS_MODAL:
            return {
                modalType: EXPORT_ADS_MODAL,
                modalProps: { propertiesIds: selectedTableRows.map((row) => row.id) },
            }
        case EXPORT_DATA_MODAL:
            return {
                modalType: EXPORT_DATA_MODAL,
                modalProps: {
                    params,
                    tableColumns: columns,
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    appModule: 'property',
                },
            }
        case PROPERTY_PRINT_FORM_MODAL:
            return {
                modalType: PROPERTY_PRINT_FORM_MODAL,
            }
        default:
            throw new Error('Unknown modal type')
    }
}
